module.exports = __webpack_public_path__ + "img/36-5fd270.png";